var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"button-back d-sm-none",attrs:{"to":_vm.link}},[_c('b-button',{staticClass:"btn_p25 fz12",attrs:{"variant":"outline-secondary_","size":"sm"}},[_c('b-icon',{attrs:{"icon":"arrow-left"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }